/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Notes_Wifi_Required_DescriptionInputs */

const en_mobile_notes_wifi_required_description = /** @type {(inputs: Mobile_Notes_Wifi_Required_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can keep listening offline. Connect to Wi-Fi to add a note.`)
};

const es_mobile_notes_wifi_required_description = /** @type {(inputs: Mobile_Notes_Wifi_Required_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puedes seguir escuchando sin conexión. Conéctate a una red Wi-Fi para añadir una nota.`)
};

/**
* | output |
* | --- |
* | "You can keep listening offline. Connect to Wi-Fi to add a note." |
*
* @param {Mobile_Notes_Wifi_Required_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_notes_wifi_required_description = /** @type {((inputs?: Mobile_Notes_Wifi_Required_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Notes_Wifi_Required_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_notes_wifi_required_description(inputs)
	return en_mobile_notes_wifi_required_description(inputs)
});